import {appRouter} from '@netx/core-next/instance/router';

export const routeToCategory = (id: number) =>
	appRouter.navigate(`category/${id}`, true);

export default routeToCategory;
